<template>
  <div>
    <Common></Common>
    <main style="width: 100%;margin: 0 auto;text-align: center;" v-loading="loading">
      <div style="font-size: 32px;font-weight: bold;text-align: center;margin-top: 20px;">会员升级</div>
      <div style="font-size: 14px;color: #666666;margin-top: 10px;">根据您当前团队规模与业务需求，选择相应套餐</div>
      <div style="margin-top: 40px;margin-bottom: 20px;display: flex;justify-content: flex-end;margin-right: 240px;">
        <el-switch
          @change="changeVipType"
          v-model="vipType"
          active-color="#ff4949"
          inactive-color="#13ce66"
          active-text="按月付费"
          inactive-text="按年付费">
        </el-switch>
      </div>
      <div class="vip-list">
        <div class="vip-item">
          <div class="header">
            <div class="vip-name">VIP 2 试用</div>
            <div class="vip-name-sm">全功能体验</div>
            <div class="vip-price">
              <div class="num" style="font-size: 32px;">试用7天</div>
            </div>
            <div style="font-size: 12px;color: #fff;" v-if="!vipType">未知</div>
          </div>
          <div class="vip-desc">
            <div><span class="func-title">地点数量</span><span>无限制</span></div>
            <div><span class="func-title">Excel 导入/导出</span><i class="el-icon-check yes"></i></div>
            <div><span class="func-title">协作人数</span><span>10</span></div>
            <div><span class="func-title">路线规划</span><i class="el-icon-check yes"></i></div>
<!--            <div><span class="func-title">一键短信通知</span><i class="el-icon-close no"></i></div>-->
            <div><span class="func-title">需求定制</span><i class="el-icon-close no"></i></div>
          </div>
          <div>
            <button @click="applyForTrialMembership">立即试用</button>
          </div>
        </div>
        <div class="vip-item">
          <div class="header">
            <div class="vip-name">VIP 2</div>
            <div class="vip-name-sm">适合小型团队</div>
            <div class="vip-price">
              <div class="num" v-if="vipType">{{ monthlyFee[2] }}</div>
              <div class="num" v-else>{{ annualFee[2] }}</div>
              <div class="vip-name-sm">元/{{ vipTypeCompany }}</div>
            </div>
            <div class="average-monthly-fee" v-if="!vipType">{{ annualFeeAverageMonthlyFee[2] }}元/月</div>
          </div>
          <div class="vip-desc">
            <div><span class="func-title">地点数量</span><span>无限制</span></div>
            <div><span class="func-title">Excel 导入/导出</span><i class="el-icon-check yes"></i></div>
            <div><span class="func-title">协作人数</span><span>5</span></div>
            <div><span class="func-title">路线规划</span><i class="el-icon-check yes"></i></div>
<!--            <div><span class="func-title">一键短信通知</span><i class="el-icon-check yes"></i></div>-->
            <div><span class="func-title">需求定制</span><i class="el-icon-close no"></i></div>
          </div>
          <div>
            <button @click="showOrder(2)">立即升级</button>
          </div>
        </div>
        <div class="vip-item">
          <div class="header">
            <div class="vip-name">VIP 3</div>
            <div class="vip-name-sm">适合中型团队</div>
            <div class="vip-price">
              <div class="num" v-if="vipType">{{ monthlyFee[3] }}</div>
              <div class="num" v-else>{{ annualFee[3] }}</div>
              <div class="vip-name-sm">元/{{ vipTypeCompany }}</div>
            </div>
            <div class="average-monthly-fee" v-if="!vipType">{{ annualFeeAverageMonthlyFee[3] }}元/月</div>
          </div>
          <div class="vip-desc">
            <div><span class="func-title">地点数量</span><span>无限制</span></div>
            <div><span class="func-title">Excel 导入/导出</span><i class="el-icon-check yes"></i></div>
            <div><span class="func-title">协作人数</span><span>10</span></div>
            <div><span class="func-title">路线规划</span><i class="el-icon-check yes"></i></div>
<!--            <div><span class="func-title">一键短信通知</span><i class="el-icon-check yes"></i></div>-->
            <div v-if="!vipType"><span>需求定制</span><span><i class="el-icon-close no"></i></span></div>
            <div v-else><span>需求定制</span><i class="el-icon-close no"></i></div>
          </div>
          <div>
            <button @click="showOrder(3)">立即升级</button>
          </div>
        </div>
        <div class="vip-item">
          <div class="header">
            <div class="vip-name">VIP 4</div>
            <div class="vip-name-sm">适合大型团队</div>
            <div class="vip-price">
              <div class="num" v-if="vipType">{{ monthlyFee[4] }}</div>
              <div class="num" v-else>{{ annualFee[4] }}</div>
              <div class="vip-name-sm">元/{{ vipTypeCompany }}</div>
            </div>
            <div class="average-monthly-fee" v-if="!vipType">{{ annualFeeAverageMonthlyFee[4] }}元/月</div>
          </div>
          <div class="vip-desc">
            <div><span class="func-title">地点数量</span><span>无限制</span></div>
            <div><span class="func-title">Excel 导入/导出</span><i class="el-icon-check yes"></i></div>
            <div><span class="func-title">协作人数</span><span>50</span></div>
            <div><span class="func-title">路线规划</span><i class="el-icon-check yes"></i></div>
<!--            <div><span class="func-title">一键短信通知</span><i class="el-icon-check yes"></i></div>-->
            <div v-if="!vipType"><span>需求定制</span><span>1</span></div>
            <div v-else><span>需求定制</span><i class="el-icon-close no"></i></div>
          </div>
          <div>
            <button @click="showOrder(4)">立即升级</button>
          </div>
        </div>
        <div class="vip-item" v-show="false">
          <div class="header">
            <div class="vip-name">定制版</div>
            <div class="vip-name-sm">根据需求定制</div>
            <div class="vip-price">
              <div class="num" style="font-size: 32px;">定制价格</div>
            </div>
            <div style="font-size: 12px;color: #fff;" v-if="!vipType">未知</div>
            <div>
              <button>联系客服</button>
            </div>
          </div>
          <div class="vip-desc">
            <div><span class="func-title">地点数量</span><span>无限制</span></div>
            <div><span class="func-title">Excel 导入/导出</span><i class="el-icon-check yes"></i></div>
            <div><span class="func-title">协作人数</span><span>定制</span></div>
            <div><span class="func-title">路线规划</span><i class="el-icon-check yes"></i></div>
<!--            <div><span class="func-title">一键短信通知</span><i class="el-icon-check yes"></i></div>-->
            <div><span class="func-title">需求定制</span><i class="el-icon-check yes"></i></div>
          </div>
        </div>
        <!---->
      </div>
    </main>
    <el-dialog
      title="扫码付费"
      :visible.sync="showState"
      width="30%"
      @close="cancelOrderPay"
      center>
      <div style="display: flex;flex-direction: column;align-items: center;">
        <img :src="paySrc" alt="">
        <div style="font-size: 30px;font-weight: bold;color: #000;">￥{{ orderInfo.amount }}</div>
        <div style="margin-top: 10px;">打开"微信"扫码支付</div>
        <el-button style="margin-top: 20px;" type="primary" @click="checkOrderPayState">已完成支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {GenerateOrder, QueryOrderPayState, ApplyForTrialMembership} from '../api/member.js'
import Header from '@/components/Header.vue'
import Common from '@/components/Common.vue'

export default {
  name: 'Member',
  components: {Header, Common},
  data () {
    return {
      loading: false,
      vipType: false, // false-年费 true-月费
      showState: false,
      paySrc: '',
      orderInfo: {},
      vipTypeCompany: '年',
      monthlyFee: { // 月费
        1: 18,
        2: 39,
        3: 49,
        4: 69
      },
      annualFee: { // 年费
        1: 168,
        2: 372,
        3: 478,
        4: 698
      },
      interval: {}, // 轮询对象
      annualFeeAverageMonthlyFee: {
        1: 14,
        2: 31,
        3: 40,
        4: 58
      },
      intervalNum: 0
    }
  },
  methods: {
    changeVipType (e) {
      if (e) {
        this.vipTypeCompany = '月'
      } else {
        this.vipTypeCompany = '年'
      }
    },
    cancelOrderPay () {
      clearInterval(this.interval)
      this.showState = false
      this.orderInfo = {}
      this.interval = {}
      this.intervalNum = 0
    },
    applyForTrialMembership () {
      var that = this
      ApplyForTrialMembership().then(res => {
        if (res.code === 200) {
          that.$notify({
            message: '申请成功',
            type: 'success'
          })
        } else {
          that.$notify({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    checkOrderPayState () {
      var that = this
      var params = {order_sn: this.orderInfo.order_sn}
      QueryOrderPayState(params).then(res => {
        if (res.code === 200) {
          if (that.interval) {
            clearInterval(that.interval)
          }
          that.showState = false
          that.orderInfo = {}
          that.$notify({
            message: '支付成功',
            type: 'success'
          })
        } else if (res.code === 1501) {
          that.$notify({
            message: res.message,
            type: 'error'
          })
        } else {
          if (that.interval) {
            clearInterval(that.interval)
          }
          that.showState = false
          that.orderInfo = {}
          that.$notify({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    showOrder (e) {
      this.loading = true
      let vipType = 2
      if (this.vipType) {
        vipType = 1
      }
      var params = {
        vip_type: vipType,
        membership_level: e
      }
      var that = this
      GenerateOrder(params).then(res => {
        that.loading = false
        if (res.code === 200) {
          that.showState = true
          that.paySrc = 'data:image/png;base64,' + res.data.qrcode
          that.orderInfo = res.data.orderInfo
          that.interval = setInterval(that.queryOrderPayState, 2000)
        } else {
          that.$notify({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    queryOrderPayState () {
      var that = this
      if (that.intervalNum >= 900) { // 长时间未支付处理
        clearInterval(that.interval)
        that.showState = false
        that.orderInfo = {}
        that.$notify({
          message: '超过30分钟未支付,请重新支付!',
          type: 'warning'
        })
        return
      }
      var params = {order_sn: this.orderInfo.order_sn}
      QueryOrderPayState(params).then(res => {
        if (res.code === 200) {
          if (that.interval) {
            clearInterval(that.interval)
          }
          that.showState = false
          that.orderInfo = {}
          that.$notify({
            message: '支付成功',
            type: 'success'
          })
        } else if (res.code === 1501) {
          that.intervalNum++
        } else {
          if (that.interval) {
            clearInterval(that.interval)
          }
          that.showState = false
          that.orderInfo = {}
          that.$notify({
            message: res.message,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.func-title{
  font-weight: 600;
}
.average-monthly-fee {
  font-size: 12px;
  color: #909399;
}

.yes {
  color: #409EFF;
  font-size: 20px;
  font-weight: bold;
}

.no {
  color: #909399;
  font-size: 20px;
  font-weight: bold;
}

.vip-list {
  position: relative;
  width: 950px;
  margin: 0 auto;
  display: flex;flex-direction: row;
  justify-content: space-between;
}
.vip-price{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 28px;
}

.vip-item {
  width: 188px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px #b5b3b3;
  border-radius: 10px;
}

.header {
  height: 180px;
  background-color: #ffffff;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 0 15px #3333331e;
}

.vip-name {
  font-size: 24px;
  color: #333333;
  line-height: 16px;
  padding-top: 30px;
  font-weight: 600;
}

.vip-name-sm {
  font-size: 14px;
  color: #666666;
  margin-top: 14px;
}


.num {
  font-size: 40px;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
  margin-right: 10px;
}

.vip-name-sm {
  font-size: 14px;
  color: #666666;
  margin-top: 14px;
}

.vip-desc {
  padding: 20px;
}

.vip-desc div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  color: #333333;
  line-height: 32px;
}

.vip-item button {
  margin-bottom: 22px;
  width: 140px;
  height: 40px;
  background-color: #2d8cf0;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

button {
  border: none;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Member.vue